import { render, staticRenderFns } from "./case-info.vue?vue&type=template&id=6f4b7b92&"
import script from "./case-info.vue?vue&type=script&lang=js&"
export * from "./case-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports